import BaseUtil from "../../util/BaseUtil";
import BusinessConstants from "../../constant/BusinessConstants";
const type = `@@ActionType/UPDATE@${__filename}`;

// 属于档案对象的类型，上传前需format
const archiveTypeArray = [
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.SPEC.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.SKILL.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.EDUEXP.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.EDU_FURTHER.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.EDU_OUTSTUDY.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.RESEARCH_PROJ.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.RESEARCH_PAPER.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.ACADIMIC_POST.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.DUTY.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.RANK.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.JOBTITLE.code,
    BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.REWARD.code,
]

const applicationTypeToGroupTypeMap = {
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.SPEC.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.SPEC_QUAL.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.SKILL.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.SKILL.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.EDUEXP.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.EDU_EXP.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.EDU_FURTHER.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.ADVANCED_FURTHER.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.EDU_OUTSTUDY.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.ADVANCED_OUTSTUDY.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.RESEARCH_PROJ.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.RESEARCH_PROJECT.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.RESEARCH_PAPER.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.RESEARCH_PAPER.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.ACADIMIC_POST.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.ACADEMIC_POST.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.DUTY.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.DUTY.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.RANK.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.RANK.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.REWARD.code]: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.REWARD.code,
    [BusinessConstants.EMPLOYEE_FLOW_BIZ_TYPE.JOBTITLE.code]: "JOB_TITLE",
}

const initState = {
    queryType: "1", // 1：待我审批的， 2：我已审批的；Menu.Item key 为 string
    pendingCount: null, // 待我审批的总数，list后的total值
    selectedUnitIds: [0], // 选中的科室ids，默认选中全部
    selectedFlowType: "all", // 选中的审批类型
    selectedStatusType: "all", // 选中的审批状态
    keyword: "", // 搜索关键词
    pageable: {
        limit: 30,
        current: 1,
        total: 0,
    },
    items: null, // 字段

    tableLoading: false, // 数据加载
    data: null, // 数据

    auditUsers: null, // 当前节点审批人员
    detailLoading: false, // 详情加载
    clickedDataDetail: null, // 点击中的数据详情
    clickedData: null, // 点击中的record
    clickedDetailContent: null, // 点中的bizContent format之后的诗句
    detailDrawerVisible: false, // 详情 drawer 可见

    approving: false, // 正在审批中

    archiveDetailVisible: false, // 档案详情
    secondmentItems: null, // 人员借调字段
    secondmentApprovalFormDrawerVisible: false, // 人员借调审批表单
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    archiveTypeArray,
    applicationTypeToGroupTypeMap,
};
export default viewModel;
